import Vue from 'vue';
import VueRouter from 'vue-router';

import Registro from '../views/RegistroTeam.vue';
import Confirmacion from '../views/ConfirmacionTeam.vue';
import Success from '../views/Success.vue';
import RegistroAux from '../views/RegistroAuxilios.vue';
import ConfirmacionAux from '../views/ConfirmacionAuxilios.vue';
import SuccessAux from '../views/SuccessAuxilios.vue';
import Finalizado from '../views/finalizado.vue';
import Registro1p from '../views/registro1p.vue';
import confirmRed from '../views/success2.vue';


Vue.use(VueRouter);

const routes = [
  {
    path: '/confirm',
    name: 'confirm',
    component: confirmRed,
    props: true,
  },
  {
    path: '/registro',
    name: 'registro',
    component: Registro1p,
    props: true,
  },
  {
    path: '/confirmacion',
    name: 'confirmacion',
    component: Confirmacion,
    props: true,
  },
  {
    path: '/success',
    name: 'success',
    component: Success,
    props: true,
  },
  {
    path: '/register',
    name: 'registrouy',
    component: Registro,
    props: true,
  },
  {
    path: '/confirmation',
    name: 'confirmacionaux',
    component: ConfirmacionAux,
    props: true,
  },
  {
    path: '/satisfactorio',
    name: 'successaux',
    component: SuccessAux,
    props: true,
  },
  {
    path: '/fin',
    name: 'fin',
    component: Finalizado,
    props: true,
  }, 
];

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

export default router;
